import { FC } from 'react';
import { edit_pencil, time_reload } from '@jat-med/assets';
import styles from './editButton.module.scss';
import { IEditButton } from './editButton.interface';
import { useTranslation } from 'react-i18next';

export const EditButton: FC<IEditButton> = ({
 onClick,
 isRescheduleIcon,
 disabled,
}) => {
 const { t } = useTranslation();
 return (
  <button
   title={isRescheduleIcon ? t('buttons.rescheduleVisit') : t('buttons.edit')}
   className={styles.edit_button}
   onClick={onClick}
   disabled={disabled}
  >
   <img
    src={isRescheduleIcon ? time_reload : edit_pencil}
    alt={isRescheduleIcon ? t('buttons.rescheduleVisit') : t('buttons.edit')}
   />
  </button>
 );
};
